<template>
  <div class="text-center">
    <v-menu v-model="menu" :close-on-content-click="true" left offset-x>
      <template v-slot:activator="{ on, attrs }">
        <v-btn x-large icon color="white" v-bind="attrs" v-on="on">
          <v-icon x-large>mdi-tooltip-account</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-avatar>
              <v-icon x-large>mdi-account</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ user.nom }}</v-list-item-title>
              <v-list-item-subtitle>{{
                user.estLimite ? "Profil demandes" : "Administrateur"
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" text @click="logout"> Se déconnecter </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  data: () => ({
    fav: true,
    menu: false,
    message: false,
    hints: true,
  }),
  computed: {
    user() {
      return this.$store.state.identite.fournisseur;
    },
  },
  methods: {
    logout() {
      this.menu = false;
      this.$store.dispatch("logout");
      this.$router.push({ name: "home" });
    },
  },
};
</script>

<style></style>
